import React, { useState } from 'react';
import moment from 'moment';
import { TableCell, TableRow, Tooltip, } from "@material-ui/core";
import { DeleteOutline, Edit } from '@material-ui/icons';
import RevertIcon from "../../../assets/images/Revert_Icon.svg"
import { checkPermission } from '../../../utils_v2';
import { displayDateFormat } from '../../../../constants';

const EngineLlpsConfigList = ({ index, item, onEditFn, onDelete, onRevert, deleteModule }) => {

    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field]
        })
    }

    return (
        <>
            <TableRow key={index} className={item?.deleted_at ? "grey-out" : ''}>
                <TableCell><div style={{ width: '150px' }}>{item?.name || '--'}</div></TableCell>
                <TableCell>{item?.llp_type?.label || '--'}</TableCell>
                <TableCell>
                    {item?.remarks && item?.remarks?.length > 30 ? (
						<div style={{ width: '500px' }}>
							{showMore[item?.field] ? (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
								</span>
							) : (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
								</span>
							)}
						</div>
					) : (
						<div style={{ width: '150px' }} dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
					)}
                </TableCell>
                <TableCell>
                    <div style={{ width: '130px' }}>
                        {item?.created_by?.name || '--'}
                        {item?.created_by?.name ?
                            <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.created_at).format(displayDateFormat)}</p> : null
                        }
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '130px' }}>
                        {item?.updated_by?.name || '--'}
                        {item?.updated_by?.name ?
                            <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.updated_at).format(displayDateFormat)}</p> : null
                        }
                    </div>
                </TableCell>
                {!deleteModule ? <TableCell>
                    <ul className="list-inline" style={{ float: 'right', display: 'inline-flex' }}>
                        {!item?.deleted_at && checkPermission('config_data', 'engine_llp_config', 'U')  ?
                            <li className="list-inline-item hover-inline" onClick={onEditFn}>
                                <Tooltip title="Edit" arrow>
                                    <Edit color="primary" fontSize="small" />
                                </Tooltip>
                            </li> : null}
                        {!item?.deleted_at && checkPermission('config_data', 'engine_llp_config', 'D')?
                            <li className="list-inline-item hover-inline" onClick={onDelete}>
                                <Tooltip title="Delete" arrow>
                                    <DeleteOutline color="secondary" fontSize="small" />
                                </Tooltip>
                            </li> : null}
                        {item?.deleted_at && checkPermission('config_data', 'engine_llp_config', 'RVT')?
                            <li className="list-inline-item hover-inline" >
                                <Tooltip title='Revert' arrow>
                                    <img
                                        src={RevertIcon}
                                        alt="Revert Icon"
                                        onClick={() => onRevert({ modal: true, data: item })}
                                        style={{ width: "1rem", height: "1rem", cursor: 'pointer', fontSize: "1.25rem", marginLeft: "2px" }}
                                        className="last-icon"
                                    />
                                </Tooltip>
                            </li>
                            : null}
                    </ul>
                </TableCell> : '' }
            </TableRow>
        </>
    )
};

export default EngineLlpsConfigList